import "./RoleRow.css";
import { useCallback } from "react";
import { DateConversion } from "@ucchub/ui";
import { useTranslation } from "react-i18next";
import circle1x from "@img/circle@1x.png";
import circle2x from "@img/circle@2x.png";
import circle3x from "@img/circle@3x.png";
import GreenTick1x from "@img/GreenTick@1x.png";
import GreenTick2x from "@img/GreenTick@2x.png";
import GreenTick3x from "@img/GreenTick@3x.png";
import { CardBox } from "@ucchub/ui";
import Image from "@vfuk/core-image";
import { useRoleManagementStore } from "src/hooks/stores";
import type UserPermission from "src/interfaces/userPermission";
import type { RolesTypes } from "@hub/common-libs";

interface RoleRowTypes {
  role: RolesTypes.RoleModel;
}
const RolesRow = ({ role }: RoleRowTypes): JSX.Element => {
  const { t } = useTranslation();
  // Actions used for icons, labels and alt-text for action buttons
  const actions = useRoleManagementStore((state) => state.getRoles.roleActions);

  const userPermissions: UserPermission = useRoleManagementStore(
    (state) => state.getPermissions
  );
  const renderRolesRows = useCallback(() => {
    return (
      <CardBox
        key={role.roleId}
        id={role.roleId}
        title={role.roleFriendlyName}
        rows={role.permissionMatrix}
        actions={actions}
        userPermissions={userPermissions}
        footer={
          role.lastUpdatedTime
            ? t("core:roles:Last_updated_on", {
                updatedOn: DateConversion(Number(role.lastUpdatedTime)),
              }) ||
              `Last updated on ${DateConversion(Number(role.lastUpdatedTime))}`
            : "NA"
        }
        image={
          <Image
            alt="Circle"
            sm={{
              src: circle1x,
            }}
            md={{
              src: circle2x,
              width: "25px",
            }}
            lg={{
              src: circle3x,
              width: "30px",
            }}
          />
        }
        image1={
          <Image
            alt="Green Tick"
            sm={{
              src: GreenTick1x,
            }}
            md={{
              src: GreenTick2x,
              width: "25px",
            }}
            lg={{
              src: GreenTick3x,
              width: "30px",
            }}
          />
        }
      />
    );
  }, [role, t, actions, userPermissions]);
  return <>{renderRolesRows()}</>;
};

export default RolesRow;
